<template>
  <div class="timeline-item-footer">
    <div class="timeline-item-start">{{ end }}</div>
    <span class="timeline-item-date">{{ date }}</span>
  </div>
</template>

<script>
export default {
  name: "TimelineItemFooter",
  props: {
    end: {
      type: String,
      required: true
    },
    date: String
  },
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";

.timeline-item-footer {
  display: flex;
}

.timeline-item-start,
.timeline-item-date {
  font-size: $size-small;
  line-height: 1.33;
  color: rgba($black, 0.72);
}

.timeline-item-date {
  border-left: 1px solid rgba($black, 0.24);
  padding-left: 0.625rem;
  margin-left: 0.625rem;
}
</style>
